import styled from 'styled-components'

import { colors } from '@/styles'
import useLanguage from '@/hooks/use-language'
import BaseHeader from '@/features/Header/base'

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
`

const LanguageLink = styled.button`
  color: ${colors.regular};
  padding: 7px 20px;
  cursor: pointer;
  background: transparent;
  border: none;
  cursor: pointer;

  :hover {
    color: rgba(48, 48, 48, 0.3);
  }
`

const Header = () => {
  const { language, changeLanguage } = useLanguage()
  const isEnglish = language.value === 'en'

  return (
    <BaseHeader>
      <Container>
        <LanguageLink onClick={() => changeLanguage(isEnglish ? 'zh' : 'en')}>
          {isEnglish ? '中文' : 'EN'}
        </LanguageLink>
      </Container>
    </BaseHeader>
  )
}
export default Header
